import { Box, Button, Container, MantineProvider, rem, Stack, Text } from "@mantine/core"
import { useNavigate } from "react-router"

export function E404(): React.ReactElement {
  const navigate = useNavigate()

  return (
    <MantineProvider defaultColorScheme="auto">
      <Container maw={rem(1280)} mx="auto">
        <Box h={"100vh"}>
          <Stack justify="center" align="center" gap={rem(8)} h={"100%"}>
            <Text size={rem(128)} fw={700} c={"dimmed"}>
              404
            </Text>
            <Text size={rem(18)} fw={500}>
              Page Not Found
            </Text>
            <Text size={rem(12)}>Please check the URL or return to the homepage.</Text>
            <Button my={rem(8)} onClick={() => navigate("/")}>
              Home
            </Button>
          </Stack>
        </Box>
      </Container>
    </MantineProvider>
  )
}
